"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PaymentContext = _interopRequireDefault(require("../../../context/PaymentContext"));
var _api = require("../../../utils/api");
var _reactIntl = require("react-intl");
var _Common = require("../../../components/Common");
var _ButtonsContainer = _interopRequireDefault(require("../../../browser/Square/ButtonsContainer"));
var _CardInputContainer = _interopRequireDefault(require("../../../browser/Square/CardInputContainer"));
var _ErrorContainer = _interopRequireDefault(require("../../../browser/Square/ErrorContainer"));
var _FormContainer = _interopRequireDefault(require("../../../browser/Form/FormContainer"));
var _FormError = _interopRequireDefault(require("../../../browser/Form/FormError"));
var _Money = _interopRequireDefault(require("../../../browser/Money"));
var _BackButton = _interopRequireDefault(require("../../../components/Square/BackButton"));
var _SubmitButton = _interopRequireDefault(require("../../../components/Square/SubmitButton"));
var _sqCardStyles = _interopRequireDefault(require("./sqCardStyles"));
var _config = _interopRequireDefault(require("../../../config"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SquareCardForm = function SquareCardForm(_ref) {
  var billingContact = _ref.billingContact,
    paymentsSdk = _ref.paymentsSdk,
    onBack = _ref.onBack;
  var _useIntl = (0, _reactIntl.useIntl)(),
    locale = _useIntl.locale;
  var _useContext = (0, _react.useContext)(_PaymentContext["default"]),
    callbacks = _useContext.callbacks,
    endpoints = _useContext.endpoints,
    guestId = _useContext.guestId,
    guestSource = _useContext.guestSource,
    paymentStore = _useContext.paymentStore,
    tenant = _useContext.tenant;
  var onError = callbacks.onError,
    onSuccess = callbacks.onSuccess,
    onSubmit = callbacks.onSubmit;
  var amount = paymentStore.amount,
    sessionId = paymentStore.sessionToken;
  var captureUrl = endpoints.squareCapture.url;
  var tenantId = tenant.id;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    card = _useState2[0],
    setCard = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var initCardPayment = function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var _card, _error;
      return _regenerator["default"].wrap(function _callee$(_context) {
        for (; 1;) switch (_context.prev = _context.next) {
          case 0:
            return _context.prev = 0, _context.next = 3, paymentsSdk.card({
              style: _sqCardStyles["default"]
            });
          case 3:
            _card = _context.sent, setCard(_card), _context.next = 11;
            break;
          case 7:
            _context.prev = 7, _context.t0 = _context["catch"](0), _error = new Error('Failed to load credit card form', {
              cause: _context.t0
            }), setError(_error);
          case 11:
            setLoading(false);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function initCardPayment() {
      return _ref2.apply(this, arguments);
    };
  }();
  var attachCard = function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2() {
      var _error2;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        for (; 1;) switch (_context2.prev = _context2.next) {
          case 0:
            if (_context2.prev = 0, _context2.t0 = card, !_context2.t0) {
              _context2.next = 5;
              break;
            }
            return _context2.next = 5, card.attach('#card-container');
          case 5:
            _context2.next = 11;
            break;
          case 7:
            _context2.prev = 7, _context2.t1 = _context2["catch"](0), _error2 = new Error('Failed to attach credit card form', {
              cause: _context2.t1
            }), setError(_error2);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function attachCard() {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    initCardPayment();
  }, []), (0, _react.useEffect)(function () {
    attachCard();
  }, [card]);
  var createCardPaymentToken = function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3() {
      var tokenResult, error;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        for (; 1;) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.next = 2, card.tokenize({
              billingContact: billingContact,
              customerInitiated: true,
              intent: 'CHARGE',
              sellerKeyedIn: false,
              total: {
                amount: amount,
                currencyCode: _config["default"].currency
              }
            });
          case 2:
            if (tokenResult = _context3.sent, tokenResult.status !== 'OK') {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", tokenResult.token);
          case 5:
            return error = new Error("Tokenization failed with status: ".concat(tokenResult.status), {
              cause: JSON.stringify(tokenResult.errors)
            }), _context3.abrupt("return", (setError(error), setLoading(false), null));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function createCardPaymentToken() {
      return _ref4.apply(this, arguments);
    };
  }();
  var createCardPayment = function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4(token) {
      var request;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        for (; 1;) switch (_context4.prev = _context4.next) {
          case 0:
            request = {
              url: captureUrl,
              method: 'post',
              params: {
                amount: amount,
                sessionId: sessionId,
                token: token
              },
              provider: 'square',
              locale: locale,
              tenantId: tenantId,
              guestSource: guestSource,
              guestId: guestId
            }, (0, _api.squareCapture)(request, function (error, response) {
              return setLoading(false), error ? (setError(error), void onError(error)) : void onSuccess(response);
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function createCardPayment(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handlePaymentMethodSubmission = function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee5(e) {
      var token;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        for (; 1;) switch (_context5.prev = _context5.next) {
          case 0:
            return e.preventDefault(), onSubmit(), setLoading(true), _context5.prev = 1, _context5.next = 4, createCardPaymentToken();
          case 4:
            token = _context5.sent, token && createCardPayment(token), _context5.next = 11;
            break;
          case 8:
            _context5.prev = 8, _context5.t0 = _context5["catch"](1), setError(_context5.t0), onError(_context5.t0);
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 8]]);
    }));
    return function handlePaymentMethodSubmission(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  return _react["default"].createElement(_FormContainer["default"], null, _react["default"].createElement(_Common.Loader, {
    visible: loading
  }), _react["default"].createElement(_Common.Header, {
    titleId: "htmPayment.square.service.initial.subtitle",
    titleValues: {
      amount: _react["default"].createElement(_Money["default"], {
        contrasting: true,
        value: amount
      })
    }
  }), _react["default"].createElement("form", {
    onSubmit: handlePaymentMethodSubmission
  }, _react["default"].createElement(_CardInputContainer["default"], {
    id: "card-container"
  }), error && _react["default"].createElement(_ErrorContainer["default"], null, _react["default"].createElement(_FormError["default"], null, error.code && _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: error.code
  }), !error.code && _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.square.error.code.DEFAULT"
  }))), _react["default"].createElement(_ButtonsContainer["default"], null, _react["default"].createElement(_BackButton["default"], {
    loading: loading,
    onClick: onBack
  }), _react["default"].createElement(_SubmitButton["default"], {
    loading: loading,
    payNow: true
  }))), _react["default"].createElement(_Common.Footer, {
    provider: "square"
  }));
};
var _default = exports["default"] = SquareCardForm;